import React from 'react'
import renderChildUIComponents from './metadata-mapper'
import Col from '../base-components/Col'
import { FlatDomainDataContext, FormBean, IUIViewColDef } from '../../datatypes';
const {MDBRow} = require('mdbreact');

interface ViewColProps {
    metadata:IUIViewColDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;
}

export default class ViewCol extends React.Component<ViewColProps,{}> {
  render() {
    const {metadata} = this.props;
    let {xs, sm, md, lg} = metadata.properties;
    const {cssClasses } = metadata;
    let className = 'viewCol ' + (cssClasses ? cssClasses : '');

    return (
        <Col xs={xs} sm={sm} md={md} lg={lg} className={className}>
          <MDBRow>
            {renderChildUIComponents(this.props)}
        </MDBRow>
        </Col>
    )
  }
}